import { useHomeQuery } from "../../../queries/useHomeQuery";

import { Categories } from "../../../components/web-app/index";
import { Loader } from "../../../components/shared/index";

const CategoriesPage = () => {
  const { data, isPending, error, isError } = useHomeQuery();

  if (isError)
    return <p>{error?.message || "Oops failed to get categories data"}</p>;

  const { categories = [] } = data || {};
  return isPending ? (
    <Loader title="Loading categories" />
  ) : (
    <Categories variant="page" categories={categories} />
  );
};

export default CategoriesPage;
